import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

/**
 * 'fund-manage': '资金管理',
 */
const route: AppRouteModule = {
  path: '/fund-manage',
  name: 'FundManage',
  component: LAYOUT,
  redirect: '/fund-manage/fund-managemant',
  meta: {
    icon: 'mingcute:certificate-line',
    title: t('routes.fund-manage.main'),
    orderNo: 1100,
    roles: [20222393],
  },
  children: [
    /**
     * fund-managemant: '资金管理',
     */
    {
      path: 'fund-managemant',
      name: 'FundManagemant',
      component: () => import('/@/views/fund-manage/fund-managemant/index.vue'),
      meta: {
        title: t('routes.fund-manage.fund-managemant'),
        roles: [20222394],
      },
    },
  ],
};

export default route;
